// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCYytFgwBI-xrg_28Tu5HAIjr35RMhK3H0",
  authDomain: "de-zoysa-travels-and-tours.firebaseapp.com",
  projectId: "de-zoysa-travels-and-tours",
  storageBucket: "de-zoysa-travels-and-tours.firebasestorage.app",
  messagingSenderId: "203084672908",
  appId: "1:203084672908:web:032c1283129ce9e9cab0a9",
  measurementId: "G-6P61F5MY88"
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
